/**
 * @file doublegamescene.js
 * @desc This module contains DoubleGameScene class definition.
 * @author Igor Kling <kling.igor.ksi@gmail.com>
 * @version 1.0.dev
 * @copyright 2016 (c) KSI Corporation
 * */

var Scene = require('scene').Scene;

var Button = require('button').Button;

var Animation = require('animation').Animation;

var network = require( './network/network_api' );


(/** @lends <global> */function (global) {
    'use strict';

    /**
     * Constructs DoubleGameScene object.
     * @class
     * @constructor
     * @param {Object} controller The delegate of double game scene - handles double game events
     * @param {Object} model Data source
     * @param {Object} config Scene configuration
     * @param {Object[]} riskHistory history of previous cards
     * @name DoubleGameScene
     * @classdesc This is a complete fully configured GUI component.
     * @extends {Scene}
     * @requires Scene
     * @requires Button
     * @tutorial 3.0-adding-doublegame-scene
     * */
    var DoubleGameScene = function(config)
    {
        Scene.call(this);

        // this.controller = controller;
        this.config = config;

        this.interactive = true;
        this.buttonMode = true;
        this.cursor = 'inherit';


        var background = new PIXI.Sprite(PIXI.utils.TextureCache[config.background.image]);
        this.addChild(background);


        if (config.screenSize) {
            this.hitArea = new PIXI.Rectangle(0, 0, config.screenSize.w, config.screenSize.h);
        }
        else {
            this.hitArea = new PIXI.Rectangle(0, 0, background.width, background.height);
        }


        this.currentWinLabel = new PIXI.extras.BitmapText("0", {font: config.currentWinLabel.font, align:config.currentWinLabel.align});
        this.addChild(this.currentWinLabel);
        this.currentWinLabel.position.set(config.currentWinLabel.position.x, config.currentWinLabel.position.y);
        this.currentWinLabel.anchor.set(0.5, 0);

        this.nextWinLabel = new PIXI.extras.BitmapText("0", {font: config.nextWinLabel.font, align:config.nextWinLabel.align});
        this.addChild(this.nextWinLabel);
        this.nextWinLabel.position.set(config.nextWinLabel.position.x, config.nextWinLabel.position.y);
        this.nextWinLabel.anchor.set(0.5, 0);

        this.blinkingCard = new Animation([PIXI.utils.TextureCache[config.centralCard.redShirt],
                                           PIXI.utils.TextureCache[config.centralCard.blueShirt]]);

        this.addChild(this.blinkingCard);
        this.blinkingCard.position.set(config.centralCard.position.x + config.centralCard.suitOffset.x, config.centralCard.position.y - config.centralCard.suitOffset.y);
        this.blinkingCard.anchor.set(0.5, 0);
        this.blinkingCard.animationSpeed = 0.2;

        this.mini_cards = [];

        this.historyLength = config.history.length;

        {
            //функция получения имени на основе файла конфигурации
            var function_getName = function(suit){
                if(config.cardTexture){
                    return config.cardTexture[suit];
                }else{
                    return suit + '.png';
                }
            };

            // red cards go first
            this.cardSuits = [config.prefix.suits + function_getName(config.suits[0]),
                config.prefix.suits + function_getName(config.suits[1]),
                config.prefix.suits + function_getName(config.suits[2]),
                config.prefix.suits + function_getName(config.suits[3])];

            this.cardMiniSuits = [config.prefix.mini_suits + function_getName(config.suits[0]),
                config.prefix.mini_suits + function_getName(config.suits[1]),
                config.prefix.mini_suits + function_getName(config.suits[2]),
                config.prefix.mini_suits + function_getName(config.suits[3])];
        }

        // // making soft copy
        // var history = riskHistory.slice();
        // if (history.length > config.history.length) {
        //     // trim old card
        //     history.splice(0, (history.length - config.history.length));
        // }

        for (var i = 0; i < this.historyLength + 1; ++i) {


            var mini_card = new PIXI.Sprite(PIXI.utils.TextureCache[this.cardMiniSuits[/*history[i].suit*/0]]);
            // карты в истории
            mini_card.position.set(config.history.position.x + i * config.history.cardOffset, config.history.position.y) ;

            var miniScale = config.history.cardScale;
            if ( ! isNaN( miniScale ) )
            {
                mini_card.scale.set( miniScale );
            }

            this.addChild(mini_card);
            this.mini_cards.push(mini_card);
        }

        this.chosen_card = new PIXI.Sprite(PIXI.utils.TextureCache[this.cardSuits[0]]);
        this.chosen_card.anchor.set(0.5, 0);
        this.chosen_card.visible = false;
        this.addChild(this.chosen_card);

        // ссылается на карту, которая будет показана после поворота рубашки
        this.currentCardId = this.historyLength;

        var createCommonButtonTexture = function(texture, labelFilename)
        {
            var sprite = new PIXI.Sprite(texture);

            var label = new PIXI.Sprite(PIXI.utils.TextureCache[labelFilename]);
            sprite.addChild(label);

            var renderTexture = PIXI.RenderTexture.create(texture.width, texture.height);
            PIXI.renderer.render(sprite, renderTexture);

            return renderTexture;
        };

        /** Временный метод для создания текстуры (накладывает саму на себя делая ее темнее), на которую наведен курсор. Лучше заказать текстуры у художников */
        var createCommonButtonOverTexture = function (texture)
        {
            var sprite = new PIXI.Sprite(texture);
            var spriteCopy = new PIXI.Sprite(texture);
            //spriteCopy.blendMode = PIXI.BLEND_MODES.SCREEN;

            sprite.addChild(spriteCopy);

            var renderTexture = PIXI.RenderTexture.create(texture.width, texture.height);
            PIXI.renderer.render(sprite, renderTexture);

            return renderTexture;
        };

        // var normalStateTexture = createCommonButtonTexture(PIXI.utils.TextureCache["big_bubble_normal.png"], "collect_button_label_normal.png");
        // var pressedStateTexture = createCommonButtonTexture(PIXI.utils.TextureCache["big_bubble_pressed.png"], "collect_button_label_normal.png");
        // var disabledStateTexture = createCommonButtonTexture(PIXI.utils.TextureCache["big_bubble_disabled.png"], "collect_button_label_disabled.png");
        // var overStateTexture = createCommonButtonOverTexture(normalStateTexture);

        var cardSelected = function(color) {
            this.redButton.interactive = false;
            this.blackButton.interactive = false;

            this.stopBlinking();

            this.controller.cardSelected(color);
        };



        //normalStateTexture, overStateTexture, pressedStateTexture, disabledStateTexture
        this.redButton = new Button(PIXI.utils.TextureCache[config.redButton.state.normal],
                                    PIXI.utils.TextureCache[config.redButton.state.over],
                                    PIXI.utils.TextureCache[config.redButton.state.pressed],
                                    PIXI.utils.TextureCache[config.redButton.state.disabled]);
        this.redButton.position.set(config.redButton.position.x, config.redButton.position.y);
        this.redButton.anchor.set(0.5, 0.0);
        this.addChild(this.redButton);
        this.redButton.enabled = false;

        if (config.redButton.hitArea === 'ellipse') {
            var lb = this.redButton.getBounds();
            this.redButton.hitArea = new PIXI.Ellipse(0, lb.height / 2, lb.width/2, lb.height / 2);
        }

        this.redButton.callback = cardSelected.bind( this, network.RISK_CHOICE.RED );

        // normalStateTexture, overStateTexture, pressedStateTexture, disabledStateTexture
        this.blackButton = new Button(PIXI.utils.TextureCache[config.blackButton.state.normal],
                                      PIXI.utils.TextureCache[config.blackButton.state.over],
                                      PIXI.utils.TextureCache[config.blackButton.state.pressed],
                                      PIXI.utils.TextureCache[config.blackButton.state.disabled]);
        this.blackButton.position.set(config.blackButton.position.x, config.blackButton.position.y);
        this.blackButton.anchor.set(0.5, 0.0);
        this.addChild(this.blackButton);
        this.blackButton.enabled = false;



        if (config.blackButton.hitArea === 'ellipse') {
            var lb = this.blackButton.getBounds();
            this.blackButton.hitArea = new PIXI.Ellipse(0, lb.height / 2, lb.width/2, lb.height / 2);
        }

        this.blackButton.callback = cardSelected.bind( this, network.RISK_CHOICE.BLACK );

        if (config.selectLabel) {
            var selectLabelRedTexture;
            var selectLabelBlackTexture;
            if ( config.selectLabel.image )
            {
                selectLabelBlackTexture = selectLabelRedTexture = PIXI.utils.TextureCache[ config.selectLabel.image ];
            }
            else
            {
                selectLabelRedTexture = PIXI.utils.TextureCache[ config.selectLabel.redImage ];
                selectLabelBlackTexture = PIXI.utils.TextureCache[ config.selectLabel.blackImage ];
            }

            this.selectLabelRed = new PIXI.Sprite( selectLabelRedTexture );
            this.addChild( this.selectLabelRed );
            this.selectLabelRed.position.set( config.selectLabel.redPosition.x, config.selectLabel.redPosition.y );
            this.selectLabelRed.anchor.set( 0.5, 0 );
            this.selectLabelRed.visible = false;

            this.selectLabelBlack = new PIXI.Sprite( selectLabelBlackTexture );
            this.addChild( this.selectLabelBlack );
            this.selectLabelBlack.position.set( config.selectLabel.blackPosition.x, config.selectLabel.blackPosition.y );
            this.selectLabelBlack.anchor.set( 0.5, 0 );
            this.selectLabelBlack.visible = false;
        }

        if (config.sounds.blink)
            this.sndBlink = sounds.get(config.sounds.blink);
        if (config.sounds.choice)
            this.sndSelect = sounds.get(config.sounds.choice);
        if (config.sounds.win)
            this.sndWin = sounds.get(config.sounds.win);
        if (config.sounds.lose)
            this.sndLose = sounds.get(config.sounds.lose);
        if (config.sounds.rotate)
            this.sndRotate = sounds.get(config.sounds.rotate);
    };

    DoubleGameScene.prototype = Object.create(Scene.prototype);

    DoubleGameScene.prototype.constructor = DoubleGameScene;

    DoubleGameScene.prototype.terminate = function () {
        this.removeChildren();
        this.destroy();

        this.config = null;

        this.currentWinLabel = null;

        this.nextWinLabel = null;

        this.blinkingCard.destroy();
        this.blinkingCard = null;

        this.mini_cards = null;
        this.cardSuits = null;
        this.cardMiniSuits = null;
        this.chosen_card = null;

        this.redButton.callback = null;
        this.redButton = null;

        this.blackButton.callback = null;
        this.blackButton = null;

        this.selectLabelRed = null;

        this.selectLabelBlack = null;

        this.sndBlink.stop();
        this.sndBlink = null;
        this.sndSelect = null;
        this.sndLose = null;
        this.sndWin = null;
        this.sndRotate = null;
    };

    /**
     * Makes scene paused
     * @memberOf DoubleGameScene
     * @override
     * */
    DoubleGameScene.prototype.pause = function() {
        // обязательный вызов базовой реализации метода
        Scene.prototype.pause();

        this.disableButtons();

        this.blinkingCard.stop();

        this.sndBlink.stop();
    };

    /**
     * Resumes scene
     * @memberOf DoubleGameScene
     * @override
     * */
    DoubleGameScene.prototype.resume = function( state ) {
        // обязательный вызов базовой реализации метода
        Scene.prototype.resume();
    };

    DoubleGameScene.prototype.disableInteraction = function () {
        // кнопки просто перестают реагировать, но видны как активные
        this.redButton.interactive = false;
        this.blackButton.interactive = false;

        this.stopBlinking();
    };

    DoubleGameScene.prototype.show_history = function( history ) {
        // making soft copy
        if (history.length > this.historyLength) {
            // trim old card
            history.splice(0, (history.length - this.historyLength));
        }
        history.reverse();


        // updating textures
        var i = 1, j = 0;
        while (j < this.historyLength) {
            i = i % (this.historyLength + 1);
            this.mini_cards[i].texture = PIXI.utils.TextureCache[this.cardMiniSuits[history[j].suit]];
            ++j;
            ++i;
        }
        this.mini_cards[0].visible = false;
    };


    //эта функция вызывается только один раз в самом начале (только в первом раунде):
    DoubleGameScene.prototype.startRound = function( riskData, $startComplete ) {

        this.show_history(riskData.history.slice());

        this.enableButtons();

        if (this.selectLabelRed) {
            this.selectLabelRed.visible = false;
        }
        if ( this.selectLabelBlack ) {
            this.selectLabelBlack.visible = false;
        }

        this.currentWinLabel.text = riskData.currentWin.toString();
        this.nextWinLabel.text = riskData.futureWin.toString();

        this.showBlinkingCard();

        $startComplete.next();
    };

    /**
     * Response on card selection action
     * @param {Number} color selected color (0 - red, 1 - black)
     * @memberOf DoubleGameScene
     * @inner
     * */
    DoubleGameScene.prototype.onCardSelect = function (color) {
        var fakePointerData = {data:{originalEvent:{button:0}}};

        if (color === network.RISK_CHOICE.RED) {
            this.redButton.emit('pointerdown', fakePointerData);
            if ( this.selectLabelRed ) {
                this.showLabel( this.selectLabelRed );
            }
        }
        else if (color === network.RISK_CHOICE.BLACK) {
            this.blackButton.emit('pointerdown', fakePointerData);
            if ( this.selectLabelBlack ) {
                this.showLabel( this.selectLabelBlack );
            }
        }
        this.redButton.interactive = false;
        this.blackButton.interactive = false;

        // this.disableButtons();

        this.stopBlinking();

        // this.controller.emergencyCallback = null;
    };


    /**
     * Fades in specified label
     * @param {Object} label Showing label
     * @memberOf DoubleGameScene
     * @inner
     * */
    DoubleGameScene.prototype.showLabel = function (label) {

        // label.alpha = 0;
        label.visible = true;
        // var fadeInTween = new TWEEN.Tween(label)
        //     .to({alpha: 1}, 200)
        //     .start();
    };

    /**
     * Fades out specified label
     * @param {Object} label
     * @memberOf DoubleGameScene
     * @inner
     * */
    DoubleGameScene.prototype.hideLabel = function (label) {
        label.visible = false;
        // var fadeOutTween = new TWEEN.Tween(label)
        //     .to({alpha: 0}, 200)
        //     .onComplete(function(){
        //         label.visible = false;
        //     })
        //     .start();
    };

    /**
     * Enables scene buttons
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.enableButtons = function () {
        this.redButton.enabled = true;
        this.blackButton.enabled = true;
    };

    /**
     * Disables scene buttons
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.disableButtons = function () {
        this.redButton.enabled = false;
        this.blackButton.enabled = false;
    };

    /**
     * Shows blinking card
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.showBlinkingCard = function() {
        this.blinkingCard.visible = true;
        this.blinkingCard.play();
        this.sndBlink.loop( true );
        this.sndBlink.play();

        // this.controller.emergencyCallback = function () {
        //     this.blinkingCard.stop();
        //     this.sndBlink.stop();
        // }.bind(this);
    };

    /**
     * Flips card
     * @param {String} suitId Card identifier 'hearts', 'diamonds', 'spades', 'clubs'
     * @param {DoubleGameScene~flipCallback} cardFlipCallback The callback that fires on flip complete
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.showCard = function (suitId, cardFlipCallback) {

        this.chosen_card.texture = PIXI.utils.TextureCache[this.cardSuits[suitId]];
        this.chosen_card.position.set(this.config.centralCard.position.x, this.config.centralCard.position.y);
        this.chosen_card.visible = true;
        this.mini_cards[0].texture = PIXI.utils.TextureCache[this.cardMiniSuits[suitId]];
        this.mini_cards[0].position.set(this.config.history.position.x, this.config.history.position.y);
        this.mini_cards[0].visible = true;

        var selected = function()
        {
            if ( this.sndRotate )
            {
                this.sndRotate.play();
            }
            cardFlipCallback();
        }.bind( this );

        if (this.sndSelect) {
            this.sndSelect.once( 'end', selected );
            this.sndSelect.play();
        }
        else {
            setTimeout(
                selected,
                100
            );
        }
    };
    /**
     * @callback DoubleGameScene~flipCallback
     * */



    /**
     * Slides flipped card to history
     * @param {DoubleGameScene~slideCardCallback} completeCallback The callback that fires on slide complete
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.slideCardToHistory = function (suitId, completeCallback) {

        this.chosen_card.visible = false;
        setTimeout(completeCallback, 200);
    };
    /**
     * @callback DoubleGameScene~slideCardCallback
     * */



    /**
     * Slides cards history
     * @param {DoubleGameScene~slideCardsCallback} completeCallback The callback that fires on history slide complete
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.slideCardsHistory = function (completeCallback) {

        for (var i = this.historyLength; i > 0; --i) {
            this.mini_cards[i].texture = this.mini_cards[i-1].texture;
        }
        this.mini_cards[0].visible = false;
        completeCallback();

    };
    /**
     * @callback DoubleGameScene~slideCardsCallback
     * */


    /**
     * Stops card blinking.
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.stopBlinking = function () {
        this.blinkingCard.stop();

        // останавливаем звук
        this.sndBlink.stop();
    };

    /**
     * Shows win scenario.
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.showWin = function (suitId, currentWin, futureWin, done) {

        var self = this;

        this.showCard(suitId, function () {

            if (self.sndWin) {
                self.sndWin.play();
            }

            self.currentWinLabel.text = currentWin.toString();
            self.nextWinLabel.text = futureWin.toString();


            setTimeout(
                function () {
                    self.blackButton.emit('pointerout');
                    self.redButton.emit('pointerout');
                    if (self.selectLabelRed) {
                        self.hideLabel(self.selectLabelRed);
                    }
                    if (self.selectLabelBlack) {
                        self.hideLabel(self.selectLabelBlack);
                    }
                    self.slideCardsHistory(function () {
                        self.slideCardToHistory(suitId, function () {

                            setTimeout(function () {
                                self.enableButtons();
                                // self.showBlinkingCard();

                                done();
                            }, 300);
                        });
                    });
                },
                700
            );
        });
    };

    /**
     * Shows loss scenario.
     * @memberOf DoubleGameScene
     * */
    DoubleGameScene.prototype.showLoss = function (suitId, done) {

        var self = this;

        this.showCard(suitId, function () {

            if (self.sndLose) {
                self.sndLose.play();
            }

            self.currentWinLabel.text = '0';
            self.nextWinLabel.text = '0';

            setTimeout(function () {
                self.blackButton.emit('pointerout');
                self.redButton.emit('pointerout');
                if (self.selectLabelRed) {
                    self.hideLabel(self.selectLabelRed);
                }
                if (self.selectLabelBlack) {
                    self.hideLabel(self.selectLabelBlack);
                }
                done();
                self.chosen_card.visible = false;
            }, 2000);
        });
    };


    DoubleGameScene.prototype.showRiskResult = function (riskData, done) {

        this.show_history(riskData.history.slice());

        if (riskData.currentWin > 0) {
            this.showWin(riskData.cardSuit, riskData.currentWin, riskData.futureWin, done);
        }
        else {
            this.showLoss(riskData.cardSuit, done);
        }
    };


    global.DoubleGameScene = DoubleGameScene;
}(typeof module === 'object' && module.exports || this));



//////////////////
// WEBPACK FOOTER
// ./src/library/novomat_redblack_gamble.js
// module id = 96
// module chunks = 0